/*** 
 * 描述：系统公共sidebar-menu部分
 */
import { Component, OnInit, HostListener, ElementRef, Input, EventEmitter, Output } from '@angular/core';
import { GetUserModelService } from 'src/app/librarys/serves/public/get-user-model.service';
import { Router } from '@angular/router';
import { SwMenuService } from 'src/app/librarys/serves/sw-menu.service';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'sw-menu',
  templateUrl: './sw-menu.component.html',
  styleUrls: ['./sw-menu.component.css']
})
export class SwMenuComponent implements OnInit {

  /**
   * 地址栏路径
   */
  @Input() url: string
  @Output() emitMaterialSearchClick = new EventEmitter(); //抛出事件

  AreasName: string; //模块名称
  UserModel: any = {}; //当前登入人 对象
  heightOfBox: string
  Body: any
  gender: any  //当前用户的性别

  isShow: boolean = false; //默认不显示下拉模块选项
  modleList = [
    { text: '项目1', id: '008cc4455e757eff066a67689a0d5a82', icon: 'icon iconfont iconbtn_card' },
    { text: '项目2', id: '2', icon: 'icon iconfont iconbtn_card' }]; //下拉组件的数据源
  activitProject: any;  //当前选中项目
  isEnUs: boolean = false; //当前语言是否为英文English 是英文为true  不是英文（是中文）为false
  menusTreeSubscriptiona: any  //侧边菜单订阅对象
  isInstanceMaterailSearchRequired = environment.isInstanceMaterailSearchRequired;
  constructor(
    private user: GetUserModelService,
    private el: ElementRef,
    private router: Router,
    private Const: SwMenuService, //菜单服务
    private http: SwHttpClientService,
    private jwt: SwJwtService
  ) {
    let currLanguage = this.jwt.getToken('language')
    if (currLanguage == 'en-US') {
      this.isEnUs = true
    } else {
      this.isEnUs = false
    }
  }

  ngOnDestroy(): void {
    if (this.menusTreeSubscriptiona) {
      this.menusTreeSubscriptiona.unsubscribe()  //取消订阅
    }
  }

  ngOnInit() {
    //获取用户信息
    this.UserModel = this.user.getUser();
    //获取用户性别,根据性别决定头像
    if (this.UserModel) {
      this.gender = this.UserModel['userDetail']['gender']
    }
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.Body = this.el.nativeElement.querySelector('aside').parentNode.parentNode.parentNode.parentNode.parentNode
      let bodyHeight = this.Body['offsetHeight']
      let BoxHeight = (bodyHeight - 50 - 65)
      this.heightOfBox = BoxHeight - 50 + 'px'
    }, 0);

    //订阅菜单发布事件
    this.menusTreeSubscriptiona = this.Const.menusTreeUpdated.subscribe(data => {
      //获取菜单数据
      let Areas = this.Const.getMenusVal();

      //如果是悬浮菜单,则取下级第一个模块
      if (Areas.css == "1" && Areas.children.length > 0) {
        //获取当前模块名称
        this.AreasName = this.isEnUs && Areas.children[0].functionNameEn ? Areas.children[0].functionNameEn : Areas.children[0].functionName;
      } else {
        //获取当前模块名称
        this.AreasName = this.isEnUs && Areas.functionNameEn ? Areas.functionNameEn : Areas.functionName;
      }
      if (data && data.clickareas) {
        //是通过点击业务模块进入的，需要展示下拉框
        this.activitProject = data.clickareas;
        this.isShow = true;
        //TODO:请求项目列表
        this.getProjectList(data.httpInfo.url, data.httpInfo.param);
      } else {
        this.isShow = false;
      }
    })
  }

  //获取项目列表
  getProjectList(url, param) {
    this.modleList = [];
    this.http.Post(url, param).subscribe(res => {
      if (res && res.code == 200 && res.data) {
        let list = res.data.records as Array<any>;
        list.forEach(element => {
          element.id = element.projectId,
            element.text = element.name
        });
        this.modleList = list;
      }
    })
  }

  //切换项目触发
  changeClick(e) {
    if (e) {
      let obj = this.modleList.find(x => x.id == e.id);
      this.Const.projectUpdated.next(obj);
    }
  }

  /**
   * 返回项目列表
   */
  backToList() {
    this.Const.projectUpdated.next(null);
    setTimeout(() => {
      this.router.navigate(['/fam/aps/ProjectDisplay'], { queryParams: { Title: '田野考古' } });
    }, 100);
  }

  @HostListener('window:resize', ['$event'])
  onresize(event) {
    if (this.Body) {
      let bodyHeight = this.Body['offsetHeight']
      let BoxHeight = (bodyHeight - 50 - 65)
      this.heightOfBox = BoxHeight - 50 + 'px'
    }
  }
  
  // 打开实体素材库检索
  openMaterialSearch(){
    this.emitMaterialSearchClick.emit('open');
  }
}

